<!--
  ~ Copyright (C) 2019 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="add-question__section add-question__section_info editor-box">
  <span class="cdk-visually-hidden" #addInfo>{{ 'translations.addInfo' | transloco }}</span>
</div>
